import { jsx as _jsx } from "react/jsx-runtime";
import LogoutIcon from "@mui/icons-material/LogoutOutlined";
import { getEnabledCpServices } from "@climatepartner/utils";
import { Layout } from "../../components/Layout";
import { useAuthenticationContext } from "../../providers/AuthenticationContext";
export function DashboardLayout({ header, children, theme, slots, sidebar, linkComponent: LinkComponent, }) {
    const { state, actions } = useAuthenticationContext();
    const { user, decodedAccessToken } = state;
    const { logout } = actions;
    const renderFooterMenu = () => {
        return [
            ...(sidebar?.footerMenu || []),
            {
                label: "Logout",
                to: "#",
                onClick: logout,
                icon: _jsx(LogoutIcon, {}),
                selected: false,
            },
        ];
    };
    const enabledServices = getEnabledCpServices(decodedAccessToken?.services ?? {}, decodedAccessToken?.organization_access ?? {});
    const organisationName = Object.keys(decodedAccessToken?.organization_access ?? {})?.[0];
    return (_jsx(Layout, { theme: theme, header: {
            user,
            slots: {
                middle: header?.slots?.middle ?? organisationName,
            },
            logoUrl: "/",
        }, slots: slots, sidebar: {
            services: enabledServices,
            customMenuItems: sidebar?.customMenuItems,
            footerMenu: renderFooterMenu(),
            currentServiceId: sidebar.currentServiceId,
        }, linkComponent: LinkComponent, children: children }));
}
//# sourceMappingURL=DashboardLayout.js.map